export const getStorage = async (key: string) => {
    return JSON.parse(localStorage.getItem(`autocomplete_${key}`) || '[]');
};

export const setCompleteStorage = (key: string, arr: string[]) => {
    localStorage.setItem(`autocomplete_${key}`, JSON.stringify(arr));
};

export const addStorageItem = async (key: string, arr: string[], item: string) => {
    if (!item || !arr) {
        return;
    }
    const newArr = [...arr];

    if (!arr.includes(item)) {
        newArr.push(item);
        setCompleteStorage(key, newArr);
    }
};

export const removeStorageItem = (key: string, arr: string[], itemToRemove: string): string[] => {
    let newArr = [...arr];
    newArr = newArr.filter((item) => item !== itemToRemove);
    setCompleteStorage(key, newArr);
    return newArr;
};
